import { hasReducedSurnameInitial, teacherNameFromSnapshot, teacherSurnameInitialFromSnapshot, UNNAMED_PERSON_LABEL } from './teacherTitle.ts';

/** Snapshot-only display policy. No staff directory or identity access belongs here. */
export function familyAssistantNamesByUid(uids: readonly string[], saved: Readonly<Record<string, string>>): Record<string, string> {
  const rows = [...new Set(uids)].map(uid => ({ uid, raw: (saved[uid] ?? '').trim(), label: teacherNameFromSnapshot(saved[uid]) }));
  const variants = new Map<string, Set<string>>();
  const counts = new Map<string, number>();
  for (const row of rows) {
    const labelKey = row.label.toLocaleLowerCase();
    counts.set(labelKey, (counts.get(labelKey) ?? 0) + 1);
    const group = variants.get(labelKey) ?? new Set<string>();
    group.add(row.raw.toLocaleLowerCase());
    variants.set(labelKey, group);
  }
  return Object.fromEntries(rows.map(row => {
    // Exact duplicate snapshots retain the existing label collapse. This does
    // not infer an identity link or solve the lead/assistant split-account case.
    const labelKey = row.label.toLocaleLowerCase();
    // The label and the initial both come from this same snapshot. Do not
    // compare the normalized "Ms." label to a stored period-less "Ms" title.
    const resolvedInitial = hasReducedSurnameInitial(row.raw);
    const initial = row.label !== UNNAMED_PERSON_LABEL && ((variants.get(labelKey)?.size ?? 0) > 1
      || (resolvedInitial && (counts.get(labelKey) ?? 0) > 1))
      ? teacherSurnameInitialFromSnapshot(row.raw) : '';
    return [row.uid, initial ? `${row.label} ${initial}` : row.label];
  }));
}
